import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { translate, TranslatorProvider } from 'react-translate';
import { CardTitle, Collapse, Row } from 'reactstrap';
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  Container,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
  FormGroup,
  Label,
} from 'reactstrap';
//hooks
import useInitialUrl from 'hooks/useInitialUrl';
// core components
import { actionLogin } from 'store/actions/usersActions';
import LegalContent from 'views/Components/LegalContent';

const LoginPage = (props) => {
  const { t } = props;
  const { language } = useSelector((state) => state.userReducer);
  const isMounted = useRef();

  /**
   * 
   * //TODO: Do a better redirection based on practice roles
      if (user && checkAccess("kilab-module")) {
        history.push("/admin/kilab/index");
      }
   */

  const [openDebug, setOpenDebug] = useState(false);

  const { data } = useParams();
  const credentials = data
    ? decodeURIComponent(escape(atob(data))).split(':')
    : null;

  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer);

  const [usernameFocus, setUsernameFocus] = useState(false);
  const [passwordFocus, setPasswordFocus] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginForm, setLoginForm] = useState({
    username: '',
    password: '',
    usernameState: '',
    passwordState: '',
  });
  const urlDefault = useInitialUrl();

  //Validations
  const loginEmail = (e) => {
    let login = {
      username: null,
      usernameState: null,
    };

    login.username = e.target.value.toLowerCase();
    if (e.target.value.length > 4) {
      login.usernameState = 'has-success';
    } else {
      login.usernameState = 'has-danger';
    }
    setLoginForm({ ...loginForm, ...login });
  };

  const loginPassword = (e) => {
    let login = {
      password: null,
      passwordState: null,
    };
    login.password = e.target.value;
    if (e.target.value.length > 2) {
      login.passwordState = 'can-continue';
    } /*else {
      login.passwordState = 'has-danger';
    }*/
    setLoginForm({ ...loginForm, ...login });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      loginForm.usernameState === 'has-success' &&
      loginForm.passwordState === 'can-continue'
    ) {
      await dispatch(
        actionLogin({
          username: loginForm.username.trim(),
          password: loginForm.password.trim(),
        })
      );
    }
  };

  useEffect(() => {
    if (data) {
      if (!user.isAuth || (credentials[0] !== user.email && credentials[0] !== user.username)) {
        localStorage.removeItem('tsd-url');
        dispatch(
          actionLogin({
            username: credentials[0],
            password: credentials[1],
          })
        );
      }
    }
  }, [data]);

  const isAuth = () => {
    if (user.isAuth && localStorage.getItem('tsd-token')) {
      props.history.push(urlDefault);
      localStorage.removeItem('tsd-url');
    }
  };

  useEffect(() => {
    document.body.classList.add('login-page');
    isAuth();
    return () => {
      document.body.classList.remove('login-page');
    };
    // eslint-disable-next-line
  }, [user.isAuth]);

  useEffect(() => {
    isMounted.current = true;
    if (isMounted.current && credentials) {
      setLoginForm({
        usernameState: 'has-success',
        passwordState: 'has-success',
        username: credentials[0],
        password: credentials[1],
      });
      localStorage.setItem('ts-temp-secret', credentials[1]);
      setPasswordFocus(true);
    }
    return () => (isMounted.current = false);
    //eslint-disable-next-line
  }, [isMounted.current]);

  return (
    <Fragment>
      <div className="content">
        <picture>
          <source
            srcSet="/General/login/ilustracion.svg"
            media="(min-width: 720px)"
          />
          <img
            src="/General/login/illustration-mobile.svg"
            width="100%"
            alt="TelePraxen"
            className="mt-5"
          />
        </picture>
        <div className="login-page">

          {/*hidden information about the environment*/}
          {/* 23/11/2022 se agrego el className d-none para que no se vea la info de debug en el ambiente demo por favor no pisar ese cambio al hacer merge */}
          <div className={(process.env.REACT_APP_ENV_NAME == "demo") || (process.env.REACT_APP_ENV_NAME == "preprod") ? "debug-info d-none" : "debug-info"} style={{ color: "black" }}>
            <div
              onClick={(e) => {
                e.preventDefault();
                setOpenDebug(!openDebug);
              }
              }
            >
              <span>
                <b className="caret" />
              </span>
            </div>

            <Collapse isOpen={openDebug}>
              <div className="debug-url">
                {process.env.REACT_APP_HOST}
              </div>
            </Collapse>
          </div>

          <Container>
            <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
              <Form onSubmit={handleSubmit}>
                <Card className="card-login card-plain">
                  <CardHeader className="login-title">
                    <img src={'/General/login/logo.svg'} width="100%" alt="" />
                    <CardTitle className="text-info">{t('login')}</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <InputGroup
                      className={
                        (usernameFocus ? ' input-group-focus ' : '') +
                        loginForm.usernameState
                      }
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <img
                            src={'/General/login/user.svg'}
                            width="15"
                            alt=""
                          />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        placeholder={t('email') + '...'}
                        onFocus={(e) => setUsernameFocus(true)}
                        onBlur={(e) => setUsernameFocus(false)}
                        onChange={loginEmail}
                        name="email_login"
                        defaultValue={credentials ? credentials[0] : ''}
                      />
                    </InputGroup>
                    <InputGroup
                      className={
                        (passwordFocus ? ' input-group-focus ' : '') +
                        loginForm.passwordState +
                        ' mb-0'
                      }
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <img
                            src={'/General/login/password.svg'}
                            width="15"
                            alt=""
                          />
                          {/* <i className="now-ui-icons text_caps-small" /> */}
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type={`${showPassword ? "text" : "password"}`}
                        placeholder={t('password') + '...'}
                        onFocus={(e) => setPasswordFocus(true)}
                        onBlur={(e) => setPasswordFocus(false)}
                        onChange={loginPassword}
                        name="pass_login"
                        defaultValue={credentials ? credentials[1] : ''}
                      />

                        <InputGroupAddon 
                        addonType="append" 
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                      >
                        <InputGroupText>
                          <span className={`icon-${showPassword ? "invisible" : "show"}`} />
                        </InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </CardBody>
                  <CardFooter>
                    {/* Switch to remember the pass */}
                    <FormGroup check>
                      <Label check>
                        <input
                          name="remember"
                          className="form-control"
                          type="checkbox"
                        />{' '}
                        <span className="form-check-sign mr-4 mb-3" />
                        <div className="keepme-text">{t('keepme')}</div>
                      </Label>
                    </FormGroup>
                    <Button
                      block
                      type="submit"
                      color="info"
                      size="sm"
                      name="button_login"
                      className="mb-3 mt-3"
                    >
                      {t('login')}
                    </Button>
                    {/*
                    <div className="pull-left">
                      <Link
                        to="/auth/register-page"
                        className="link footer-link"
                      >
                        {t('create-account')}
                      </Link>
                    </div>
                    */}
                    <div className="login-form-bottom">
                      <Link
                        to="/auth/register-page"
                        className="link link-flex footer-link"
                      >
                        {t('create-account')}
                      </Link>
                      <Link
                        to="/auth/forgot-password"
                        className="link footer-link link-right"
                      >
                        {t('need-help')}
                      </Link>
                    </div>
                  </CardFooter>
                </Card>
              </Form>
            </Col>
            <Row className="ml-auto mr-auto d-none d-sm-block justify-content-center">
              <TranslatorProvider translations={require(`assets/i18n/terms/${language || 'de'}.json`)}>
                <LegalContent />
              </TranslatorProvider>
            </Row>
          </Container>
        </div>
      </div>
      {/* <div
        className="full-page-background"
        style={{ backgroundImage: "url(" + bgImage + ")" }}
      /> */}
    </Fragment>
  );
};

export default translate('login-page')(LoginPage);
